import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast } from "../../../toast/Toasts";
import moment from "moment";
import { getRequestId } from "../../../_helpers/miscUtils";
// import {
//   DUMMY_REVIEWFLIGHTDETAILS,
//   DUMMY_SEAT_MAP_RESPONSE,
// } from "../../../_constants/constant";

export const getGroupwiseTravellerByUserID = createAsyncThunk(
  "TravellersInformation/FindBirthdateByUserID",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/TravellersInformation/FindBirthdateByUserID`,
        payload
      );
      const formatedResponse = {
        adults: response.data?.Data.AdultDataView?.map((e: any) => ({
          ...e,
          first_name: e?.first_name,
          last_name: e?.last_name,
          gender: e?.gender ? `${e?.gender}` : "",
          mobile_no: e?.mobile_no,
          email_id: e?.email_id,
          isSelected: false,
          initial: e?.initial,
          date_of_birth: e?.date_of_birth,
          passport_no: e?.passport_no,
          issue_country_code: e?.issue_country_code,
          // issue_date: e?.issue_date,
          expire_date: e?.expire_date,
        })),
        children: response.data?.Data.ChildDateView?.map((e: any) => ({
          ...e,
          first_name: e?.first_name,
          last_name: e?.last_name,
          gender: e?.gender ? `${e?.gender}` : "",
          isSelected: false,
          initial: e?.initial,
          date_of_birth: e?.date_of_birth,
          passport_no: e?.passport_no,
          issue_country_code: e?.issue_country_code,
          // issue_date: e?.issue_date,
          expire_date: e?.expire_date,
        })),
        infants: response.data?.Data.InfantDataView?.map((e: any) => ({
          ...e,
          first_name: e?.first_name,
          last_name: e?.last_name,
          gender: e?.gender ? `${e?.gender}` : "",
          date_of_birth: e?.date_of_birth,
          isSelected: false,
          initial: e?.initial,
          passport_no: e?.passport_no,
          issue_country_code: e?.issue_country_code,
          // issue_date: e?.issue_date,
          expire_date: e?.expire_date,
        })),
      };
      return formatedResponse;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error get travellers by user:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAirlineReprice = createAsyncThunk(
  "AirlineReprice/Air_Reprice",
  async (payload: any) => {
    const Request_Id = getRequestId();
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineReprice/Air_Reprice`,
        { ...payload, Request_Id }
      );
      // return DUMMY_REVIEWFLIGHTDETAILS;
      if (
        response.data?.Response_Header?.Error_Code !== "0000" ||
        !response.data?.AirRepriceResponses
      ) {
        ErrorToast(
          response.data?.Response_Header?.Error_Desc || "Something went wrong!"
        );
      } else {
        return response.data;
      }
    } catch (error: any) {
      ErrorToast(
        (error?.response?.data?.errors[0] &&
          error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!"
      );
      return Promise.reject({
        message:
          (error?.response?.data?.errors[0] &&
            error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!",
      });
    }
  }
);

export const getSeatMap = createAsyncThunk(
  "AirlineGetSeatMap/Air_GetSeatMap",
  async (payload: any) => {
    const Request_Id = getRequestId();
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineGetSeatMap/Air_GetSeatMap`,
        { ...payload, Request_Id }
      );

      // return DUMMY_SEAT_MAP_RESPONSE;
      // if (
      //   response.data?.Response_Header?.Error_Code !== "0000" ||
      //   !response.data?.AirSeatMaps
      // ) {
      //   ErrorToast(
      //     response.data?.Response_Header?.Error_Desc || "Something went wrong!"
      //   );
      // } else {
      return response.data?.AirSeatMaps;
      // }
    } catch (error: any) {
      ErrorToast(
        (error?.response?.data?.errors[0] &&
          error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!"
      );
      return Promise.reject({
        message:
          (error?.response?.data?.errors[0] &&
            error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!",
      });
    }
  }
);

export const getSSRList = createAsyncThunk(
  "AirlineGetSSR/Air_GetSSR",
  async (payload: any) => {
    const Request_Id = getRequestId();
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineGetSSR/Air_GetSSR`,
        { ...payload, Request_Id }
      );
      // const segmentWiseSSR = groupSSRBySegment(
      //   response.data?.SSRFlightDetails || []
      // );
      return response.data?.SSRFlightDetails;
    } catch (error: any) {
      ErrorToast(
        (error?.response?.data?.errors[0] &&
          error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!"
      );
      return Promise.reject({
        message:
          (error?.response?.data?.errors[0] &&
            error?.response?.data?.errors[0]?.message) ||
          "Something went wrong!",
      });
    }
  }
);

// export const getConfirmFlightBooking = createAsyncThunk(
//   "AirlineReprint/Air_Reprint",
//   async (payload: any) => {
//     try {
//       const response = await axiosApiInstance.post(
//         `${API_URL}/AirlineReprint/Air_Reprint`,
//         payload
//       );
//       return response.data;
//     } catch (error: any) {
//       ErrorToast(
//         (error?.response?.data?.errors[0] &&
//           error?.response?.data?.errors[0]?.message) ||
//           "Something went wrong!"
//       );
//       return Promise.reject({
//         message:
//           (error?.response?.data?.errors[0] &&
//             error?.response?.data?.errors[0]?.message) ||
//           "Something went wrong!",
//       });
//     }
//   }
// );

export const saveFlightBooking = createAsyncThunk(
  "FlightBooking/InsertFlightBooking",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightBooking/InsertFlightBooking`,
        payload
      );

      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error insert booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const saveTempFlightBooking = createAsyncThunk(
  "FlightBooking/InsertTempFlightBooking",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/FlightBooking/InsertTempFlightBooking`,
        payload
      );

      return response.data?.Data;
    } catch (error: any) {
      console.error("Error insert tempbooking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const flightTempBooking = createAsyncThunk(
  "AirlineTempBooking/Air_TempBooking",
  async (payload: any) => {
    const Request_Id = getRequestId();
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineTempBooking/Air_TempBooking`,
        { ...payload, Request_Id }
      );

      if (
        response.data?.Response_Header?.Error_Code !== "0000" ||
        !response.data?.Booking_RefNo
      ) {
        ErrorToast(
          response.data?.Response_Header?.Error_Desc || "Something went wrong!"
        );
      } else {
        return response.data;
      }
    } catch (error: any) {
      console.error("Error insert tempbooking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const addPayment = createAsyncThunk(
  "AirlineAddPayment/AddPayment",
  async (payload: any) => {
    const Request_Id = getRequestId();
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineAddPayment/AddPayment`,
        { ...payload, Request_Id }
      );

      if (
        response.data?.Response_Header?.Error_Code !== "0000" ||
        !response.data?.Amount ||
        !response.data?.PaymentID
      ) {
        ErrorToast(
          `${
            response.data?.Response_Header?.Error_Desc ||
            "Payment successful! Booking issue encountered, we'll update you soon or refund in 3-5 days."
          }`
        );
      } else {
        return response.data;
      }
    } catch (error: any) {
      console.error("Error insert tempbooking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// need to manage pending booking and failed booking too
export const confirmFlightBooking = createAsyncThunk(
  "AirlineTicketing/Air_Ticketing",
  async (payload: any) => {
    const Request_Id = getRequestId();
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AirlineTicketing/Air_Ticketing`,
        { ...payload, Request_Id }
      );

      // return response.data;
      if (response.data?.Response_Header?.Status_Id === "22") {
        ErrorToast(
          response.data?.Response_Header?.Error_Desc ||
            "Your payment was successful, but the booking is currently in progress. Please wait a few moments and avoid initiating a new booking."
        );
        return response.data;
      } else if (
        response.data?.Response_Header?.Error_Code !== "0000" ||
        !response.data?.Booking_RefNo ||
        !response.data?.AirlinePNRDetails
      ) {
        ErrorToast(
          response.data?.Response_Header?.Error_Desc ||
            "Your payment was successful, but we encountered an issue with the booking. Our team will update you shortly, or a refund will be processed within 3–5 business days."
        );
        return response.data;
      } else {
        return response.data;
      }
    } catch (error: any) {
      console.error("Error insert booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createPaymentOrder = createAsyncThunk(
  "RazorpayGateway/CreateOrder",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/RazorpayGateway/CreateOrder`,
        payload
      );

      return response.data;
    } catch (error: any) {
      console.error("Payment Order Created failed:", error);
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Payment Order Created failed",
      });
    }
  }
);

export const verifyPayment = createAsyncThunk(
  "RazorpayGateway/verify",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/RazorpayGateway/verify`,
        payload
      );

      return response.data;
    } catch (error: any) {
      console.error("Payment verification failed:", error);
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Payment verification failed",
      });
    }
  }
);

export const savePanInfo = createAsyncThunk(
  "User/UpdateBillingPanCardNo",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/User/UpdateBillingPanCardNo`,
        payload
      );

      return response.data;
    } catch (error: any) {
      console.error("Payment verification failed:", error);
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Payment verification failed",
      });
    }
  }
);

export const getHandlingFees = createAsyncThunk(
  "AdminSettings/FindByIDHandlingFees",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdminSettings/FindByIDHandlingFees`,
        {
          ID: 1,
        }
      );
      const result = response.data?.Data as any;
      return {
        International_Cancellation_Fee: result?.International_Cancellation_Fee,
        International_Conv_Fee: result?.International_Conv_Fee,
        Domestic_Cancellation_Fee: result?.Domestic_Cancellation_Fee,
        Domestic_Conv_Fee: result?.Domestic_Conv_Fee,
        GSTPer: result?.GSTPer,
      };
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching handling fees:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getChargesByMembershipPlan = createAsyncThunk(
  "MembershipPlan/GetMembershipPlanCharges",
  async (user_guid: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/MembershipPlan/GetMembershipPlanCharges`,
        {
          user_guid,
        }
      );
      const result = response.data?.Data as any;
      return {
        InternationalFlightCharge: result?.InternationalFlightCharge,
        DomesticFlightCharge: result?.DomesticFlightCharge,
        PlanName: result?.PlanName,
        ID: result?.ID,
      };
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching handling fees:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getPromoCodeDetails = createAsyncThunk(
  "PromoCode/FindByPromoCode",
  async (PromoCode: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/PromoCode/FindByPromoCode`,
        { PromoCode }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        PromoCode: result.PromoCode,
        FromDate: result.FromDate ? moment(result.FromDate).toDate() : "",
        ToDate: result.ToDate ? moment(result.ToDate).toDate() : "",
        DiscountType: result.DiscountType,
        Value: result.Value,
        MaxDiscount: result.MaxDiscount,
        ApplyOn: result.ApplyOn,
        IsActive: result.IsActive ? 1 : 2,
      } as any;
    } catch (error: any) {
      ErrorToast("Sorry! Promocode used is not applicable at the moment");
      console.error("Error Fetching PromoCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const reedemGiftCodeForBooking = createAsyncThunk(
  "GiftCode/ReedemGiftCodeForBooking",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/ReedemGiftCodeForBooking`,
        payload
      );
      const result = response.data?.Data as any;
      return result;
      // return {
      //   ID: result.ID,
      //   PromoCode: result.PromoCode,
      //   FromDate: result.FromDate ? moment(result.FromDate).toDate() : "",
      //   ToDate: result.ToDate ? moment(result.ToDate).toDate() : "",
      //   DiscountType: result.DiscountType,
      //   Value: result.Value,
      //   MaxDiscount: result.MaxDiscount,
      //   ApplyOn: result.ApplyOn,
      //   IsActive: result.IsActive ? 1 : 2,
      // } as any;
    } catch (error: any) {
      ErrorToast("Sorry! Gift Code used is not applicable at the moment");
      console.error("Error Fetching PromoCodes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const verifyGiftCodeOtp = createAsyncThunk(
  "GiftCode/ReedemGiftCodeOTPVerify",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GiftCode/ReedemGiftCodeOTPVerify`,
        payload
      );
      return response.data;
    } catch (error: any) {
      console.error("Payment verification failed:", error);
      ErrorToast(
        error?.response?.data?.Details || "Gift code OTP verification failed"
      );
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Payment verification failed",
      });
    }
  }
);
